
import { defaultEmployee, IEmployee } from 'features/setup/models/Employee';

export type EmployeeDeductionType = 'base' | 'advanceOnCommission' | 'commission' | 'policy' | 'advance' | 'policy-retraction' | 'policy-suspension';

export interface IEmployeeDeduction {
  id: number, 

  type: EmployeeDeductionType,

  code: string,
  issueDate: Date,
  status: string,
  statusDate: Date,
  statusPurpose: string,

  employeeId: number,
  personId: number,
      
  employeeRegistrationNumber: string,
  //personAgentManualCode: string,
  employeeStatus: string,

  employee: IEmployee,

  personFullName: string,
  personFullNameFR: string,
  personFullNameEN: string,

  deductionType: string,
  description: string,
  deductionDate: Date,
 
  amount: number,  
  withTax: boolean;

  isExceptional: boolean,
  commissionId: number,
  policyId: number,
  advanceId: number
}

export const defaultEmployeeDeduction : IEmployeeDeduction = {
  id: 0,

  type: 'base',

  code: '',
  issueDate: new Date(),
  status: '95',
  statusDate: new Date(),
  statusPurpose: '',
  
  employeeId: 0,
  personId: 0,
  
  employeeRegistrationNumber: '',
  //personAgentManualCode: '',
  employeeStatus: '',

  employee: defaultEmployee,

  personFullName: '',
  personFullNameFR: '',
  personFullNameEN: '',

  deductionType: '',
  description: '',
  deductionDate: new Date(),
  
  amount: 0,  
  withTax: false,

  isExceptional: false,
  commissionId: 0,
  policyId: 0,
  advanceId: 0
}

export interface IEmployeeDeductionSearch {

  type: number,
  deductionType: string,
  name: string,
  description: string,  

  dateFrom: Date,
  dateTo: Date
}
